import React, { Component } from 'react';
import { Form, Row, Col, Button, message, Spin, Icon, Popconfirm } from 'antd';
import { generate } from 'generate-password';
import connect from "react-redux/es/connect/connect";
import { hashHistory } from 'react-router';

import { deleteContributor, addChannelAction } from '../actions/channelsStoreActions';

import {
  postChannelUstream,
  putChannelUstream,
  createContributor,
  excludeContributorFromChannel,
  secondaryApp,
  database
} from "../services/firebase/firebase";

import ImageUploader from './Items/ImageUploader';
import Input from '../components/UI/Input/Input';

import { updateObject } from '../shared/utility';

const defaultPlaceholderImage = "https://firebasestorage.googleapis.com/v0/b/implant-compare.appspot.com/o/images%2Fplaceholder.png?alt=media&token=18740d81-a9cd-4c0c-b98e-8f93cb4fa52c";

class CreateChannel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controls: {
        title: {
         elementType: 'input',
         label: 'Title',
         elementConfig: {
           type: 'text',
           placeholder: 'Channel title'
         },
         value: '',
         validation: {
           required: true
         },
         valid: false,
         touched: false
       },
       description: {
         elementType: 'textarea',
         label: 'Description',
         elementConfig: {
           rows: 5,
           placeholder: 'Channel Description',
           id: "description"
         },
         value: '',
         validation: {

         },
         valid: false,
         touched: false
       }
      },
      sending: false,
      PhotoUrl: "" ,
      thumbnailName: "" ,
      isImageDataSent: true,
      values: props.channel,
    };

    this.defaultState = {...this.state};
  }

  async componentDidMount() {
    if (!this.props.isNotEdit) {
      const { title, description, thumbnail, ownerId } = this.props.channel;
      const updatedControls = updateObject(this.state.controls, {
        title: updateObject(this.state.controls.title, {
          value: title
        }),
        description: updateObject(this.state.controls.description, {
          value: description
        })
      });

      let result = await database.ref('users').once('value');
      result = result.val();

      if (result) {
        const keys = Object.keys(result);
        const allUsers = ownerId && keys.map(key => {
          return {
            email: result[key].Email,
            id: key,
          }
        });
        const usersWithEmail = (allUsers || []).filter(function(user){
          return this.indexOf(user.id) >= 0
        }, ownerId);
        const usersWithoutEmail = (ownerId || []).filter(function(userId) {
          return this.map(user => user.id).indexOf(userId) < 0;
        }, usersWithEmail).map(id => {
          return {
            email: null,
            id: id,
          }
        });
        const outputUsers = [...usersWithEmail, ...usersWithoutEmail];
        this.setState({
          controls: updatedControls,
          thumbnail: thumbnail,
          contributors: outputUsers
        });
      }
    }

    if (this.props.isNotEdit) {
      const updatedControls = updateObject(this.state.controls, {
        contributor1: {
          elementType: 'input',
          label: 'Contributor #1',
          elementConfig: {
            type: 'text',
            placeholder: 'contributor1@implant.com',
            id: "contributor1",
          },
          value: '',
          validation: {

          },
          valid: false,
          touched: false
        },
        contributor2: {
          elementType: 'input',
          label: 'Contributor #2',
          elementConfig: {
            type: 'text',
            placeholder: 'contributor2@implant.com',
            id: "contributor2",
          },
          value: '',
          validation: {

          },
          valid: false,
          touched: false
        },
        contributor3: {
          elementType: 'input',
          label: 'Contributor #3',
          elementConfig: {
            type: 'text',
            placeholder: 'contributor3@implant.com',
            id: "contributor3",
          },
          value: '',
          validation: {

          },
          valid: false,
          touched: false
        },
        contributor4: {
          elementType: 'input',
          label: 'Contributor #4',
          elementConfig: {
            type: 'text',
            placeholder: 'contributor4@implant.com',
            id: "contributor4",
          },
          value: '',
          validation: {

          },
          valid: false,
          touched: false
        },
        contributor5: {
          elementType: 'input',
          label: 'Contributor #5',
          elementConfig: {
            type: 'text',
            placeholder: 'contributor5@implant.com',
            id: "contributor5",
          },
          value: '',
          validation: {

          },
          valid: false,
          touched: false
        }
      });

      this.setState({controls: updatedControls});
    }
  }

  inputChangeHandler = (event, controlName) => {
    const updatedControls = updateObject(this.state.controls, {
      [controlName]: updateObject(this.state.controls[controlName], {
        value: event.target.value,
        // valid: checkValidaty(event.target.value, this.state.controls[controlName.validation]),
        touched: true
      })
    });
    this.setState({controls: updatedControls});
  };

  resetStateValue = () => {
    this.setState(this.defaultState);
  };

  async submitChannelForm(e) {
    e.preventDefault();

    if (this.validateFields()) {
      this.setState({sending: true});
      this.sendChannelData()
        .then((data) => {
          if (data && data.id) {
            this.setState({
              sending: false,
              isImageDataSent: true
            });

            hashHistory.push(`/Channels/${data.id}`);
          }
        })
        .catch(error => {message.error(`Error ${error}`)})
    }
  }

  validateFields() {
    if (!this.state.controls.title.value) {
      message.warn('Title is required');
      return false
    }

    // if (!this.state.imageUrl || this.state.imageUrl.length === 0) {
    //   message.warn('Image channel is required');
    //   return false
    // }

    return true
  }

  async sendChannelData() {
    const { controls, PhotoUrl, thumbnailName, values } = this.state;
    const title = controls.title.value;
    const description = controls.description.value;

    const { isAdmin, isNewElement } = this.props;
    const channelData = {
      title: title,
      description: description,
      thumbnail: PhotoUrl,
      thumbnailName: thumbnailName,

    };

    if (isNewElement && isAdmin) {
      return postChannelUstream(channelData)
        .then(res => {
          if (res.error) {
            this.setState({sending: false});
            return message.warning('Channel limit reached. Please reach out to your administrator to create new channel.');
          }

          const channel = {
            ...res,
            title: channelData.title
          };

          let extendedChannelData = {
            ...channelData,
            ...channel
          }

          const keys =  Object.keys(controls);
          const contributorKeys = keys.filter(item => {
            return item.indexOf('contributor') !== -1
          });

          const noEmptyContributors = [];
          contributorKeys.forEach(key => {
            if (controls[key].value) {
              noEmptyContributors.push(controls[key].value);
            }
          });

          noEmptyContributors.length !== 0 && this.asyncForEach(noEmptyContributors, async (email) => {
            const userData = {
              DisplayName: '',
              Email: email,
              PhotoUrl: defaultPlaceholderImage,
              biography: '',
              instagram: ''
            };
            const password = generate({
              length: 10,
              numbers: true
            });

            try {
              const firebaseUser = await secondaryApp.auth().createUserWithEmailAndPassword(email, password);
              if (firebaseUser) {

                  await createContributor(userData, channel, firebaseUser.user, password);

                  extendedChannelData = {
                    ...extendedChannelData,
                    ownerId: noEmptyContributors
                  };
                  // return response && response.data
              }
            } catch (error) {
              message.error(`Error ${error}`);
              throw new Error(`Error ${error}`);
            }
          });

          message.success('Channel created');
          this.resetStateValue();
          this.props.addChannelAction(extendedChannelData);

          return res
        })
        .catch(error => {
          message.error(`Error ${error}`)
        });
    } else {
      values.title = title;
      values.description = description;
      values.thumbnail = PhotoUrl;
      values.thumbnailName = thumbnailName;

      return putChannelUstream(values)
        .then(res => {
          message.success('Channel edited');

          return res
        })
        .catch(error => {
          message.error(`Error ${error}`)
        });
    }

  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }

  updateValue(target, value) {
    this.setState({
      values: {
        ...this.state.values,
        [target]: value,
      },
    });
  }

  handleUpdateImage(url, thumbnailName) {
    message.success('Image uploaded. Please, save form');
    this.setState({
      PhotoUrl: url,
      thumbnailName: thumbnailName,
      isImageDataSent: false,
    });
  }

  changeContributorsNumber = (event, type) => {
    event.preventDefault();

    const keys =  Object.keys(this.state.controls);
    const matchedKey = keys.filter(item => {
      return item.indexOf('contributor') !== -1
    });
    const matchedKeyLength = matchedKey.length;

    if (type === 'add') {
      const newFieldData = {
        [`contributor${matchedKeyLength + 1}`]: {
          elementType: 'input',
          label: `Contributor #${matchedKeyLength + 1}`,
          elementConfig: {
            type: 'text',
            placeholder: `contributor${matchedKeyLength + 1}@implant.com`,
            id: `contributor${matchedKeyLength + 1}`
          },
          value: '',
          validation: {

          },
          valid: false,
          touched: false
        }
      };

      const updatedControls = updateObject(this.state.controls, newFieldData);
      this.setState({controls: updatedControls});
    }

    if (type === 'delete') {
      keys.length = keys.length - 1;
      const updatedControls = keys.reduce((prev, next) => {
        const value = this.state.controls[next];
        prev[next] = value;

        return prev;
      }, {});

      this.setState({controls: updatedControls});
    }
  };

  async handleDeleteContributor(contributorId){
    const { contributors } = this.state;
    const { id, ownerId } = this.props.channel;

    const updatedStateContributors = contributors.filter(contributor => {
      return contributor.id !== contributorId;
    });
    const updatedOwnerList = ownerId.filter(id => {
      return id !== contributorId;
    });

    try {
      const response = await excludeContributorFromChannel(contributorId, id, updatedOwnerList);
      // return response && response.data
    } catch (error) {
      message.error('Something went wrong: ' + error);
    }

    const payload = {
      id: id,
      contributors: updatedOwnerList
    };
    this.props.deleteContributor(payload);
    this.setState({
      contributors: updatedStateContributors
    });
    message.success('Contributor deleted');
  }

  render() {
    const { isAdmin, channel, user, isNewElement } = this.props;

    let preloader = '';
    if (this.state.sending) {
      preloader = (
        <div className="preloader-wr">
          <Spin className="preloader" />
        </div>
      );
    }

    let isOwnChannel = (channel && channel.ownerId && channel.ownerId.length > 0 && user) &&
      channel.ownerId.find(userId => userId === user.userClaims.user_id);

    const formElementsArray = [];
    for (let key in this.state.controls) {
      formElementsArray.push({
        id: key,
        config: this.state.controls[key]
      })
    }

    let form = formElementsArray.map(formElement => (
      <Input
        label={formElement.config.label}
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        shouldValidate={formElement.config.validation}
        touched={formElement.config.touched}
        invalid={!formElement.config.valid}
        changed={(event) => this.inputChangeHandler(event, formElement.id)}
      />
    ));

    const keys =  Object.keys(this.state.controls);
    const matchedKey = keys.filter(item => {
      return item.indexOf('contributor') !== -1
    });
    const matchedKeyLength = matchedKey.length;

    let contributorsInfo = (
      <Row type="flex" className="edit-form-button-bar">
        <Col xs={24} md={12}>
          <Form.Item className="form-center-buttons">
            <Row>
              <Col>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                disabled={!(isAdmin || isOwnChannel)}
                onClick={(event) => this.changeContributorsNumber(event, 'add')}
              >
                Add Contributor
              </Button>
              </Col>
            </Row>
            {matchedKeyLength !== 0 && <Row>
              <Col>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                disabled={!(isAdmin || isOwnChannel)}
                onClick={(event) => this.changeContributorsNumber(event, 'delete')}
              >
                Delete Contributor
              </Button>
              </Col>
            </Row>}
          </Form.Item>
        </Col>
      </Row>
    );

    if (!this.props.isNotEdit && this.state.contributors) {
      contributorsInfo = (
        <Row type="flex" className="edit-form-button-bar">
          <Col xs={24} md={12} className="contributors-container">
            <h4>Channel Contributors List:</h4>
            <div className="contributors-list">
              {
                this.state.contributors.map(contributor => (
                  <div key={contributor.id} className="contributor-item">
                    <div className="contributor-name">
                      {contributor.email ? contributor.email : contributor.id}
                    </div>
                    <div className="delete-contributor">
                      <Popconfirm
                        title={`Do you really want to delete this contributor?`}
                        onConfirm={() => this.handleDeleteContributor(contributor.id)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Icon type="close" />
                      </Popconfirm>
                    </div>
                  </div>
                ))
              }
              {
                this.state.contributors.length === 0 && 'None'
              }
            </div>
          </Col>
        </Row>
      );
    }

    return (
      <React.Fragment>
        <Form onSubmit={(e) => this.submitChannelForm(e)} className="edit-form">
          <Row type="flex">
            <Col
              xs={24}
              md={{ span: 11, push: 1, order: 2 }}
              className="center-column"
            >
              <ImageUploader
                className="avatar-uploader"
                uploadText="Add Avatar"
                uploadItemAction={(downloadURL, thumbnailName) => this.handleUpdateImage(downloadURL, thumbnailName)}
                newElement={isNewElement}
                isImageDataSent={this.state.isImageDataSent}
                imageUrl={this.state.PhotoUrl || ''}
                thumbnailName={this.state.thumbnailName || ''}
                onImageUpload={(url, thumbnailName) => this.handleUpdateImage(url, thumbnailName)}
              />
            </Col>
            <Col xs={24} md={12}>
              {form}
            </Col>
          </Row>

          {contributorsInfo}

          <Row type="flex" className="edit-form-button-bar">
            <Col xs={24} md={12}>
              <Form.Item className="form-center-buttons">
                <Row>
                  <Col>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-form-button"
                      disabled={!(isAdmin || isOwnChannel)}
                    >
                      {isNewElement ? "Create Channel" : "Edit Channel"}
                    </Button>
                  </Col>
                </Row>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        {preloader}
      </React.Fragment>
    );
  }
}

export default connect(
  null,
  { deleteContributor, addChannelAction }
)(CreateChannel);



// WEBPACK FOOTER //
// ./src/components/CreateChannel.js